export default __webpack_public_path__ + "static/media/Flag_of_Portugal.0defa2ab.svg";